import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from '../../../common/components/runtime-context';
import { ShareIcon } from '../../components/icons/share-icon';
import ActionButton from '../../components/action-button';
import { isPreview } from '../../../common/store/basic-params/basic-params-selectors';
import { getPost } from '../../selectors/post-selectors';
import { getCategory } from '../../../common/selectors/categories-selectors';
import withTranslate from '../../../common/components/with-translate/with-translate';
import withPermissions from '../../hoc/with-permissions';
import withDeviceType from '../../hoc/with-device-type';
import withAuth from '../../hoc/with-auth';
import withNativeShare from '../../hoc/with-native-share';
import { getSectionUrl } from '../../../common/store/location/location-selectors';
import { copyTextToClipboard } from '../../../utils/copy-text-to-clipboard';
import { LINK_COPIED_SUCCESS, LINK_COPIED_FAILURE } from '../../components/messages/message-types';

export class CommentActions extends Component {
  showShare = () => {
    return !this.props.isEditor && !this.props.isPreview;
  };

  componentDidMount() {
    this.props.actionsOpened({ type: 'comment' });
  }

  componentWillUnmount() {
    this.props.actionsClosed({ type: 'comment' });
  }

  copyLink = async () => {
    const { comment, sectionUrl, showMessage } = this.props;
    const commentUrl = `${sectionUrl}/main/comment/${comment._id}`;

    if (copyTextToClipboard(commentUrl)) {
      showMessage(LINK_COPIED_SUCCESS);
    } else {
      showMessage(LINK_COPIED_FAILURE);
    }
  };

  render() {
    const { canRender, comment, t, theme } = this.props;

    const shareButton = canRender([['read', 'comment', comment]], () => (
      <ActionButton dataHook="comment-actions__share" onClick={this.copyLink} theme={theme}>
        <ShareIcon />
        {t('share-link.copy')}
      </ActionButton>
    ));

    // @TODO report, delete and mark as best need to be updated for new comments
    return <div>{this.showShare() && shareButton}</div>;
  }
}

CommentActions.propTypes = {
  comment: PropTypes.object.isRequired,
  post: PropTypes.object.isRequired,
  category: PropTypes.object.isRequired,
  actionsOpened: PropTypes.func.isRequired,
  actionsClosed: PropTypes.func.isRequired,
  canRender: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  isEditor: PropTypes.bool,
  isPreview: PropTypes.bool,
  sectionUrl: PropTypes.string,
  theme: PropTypes.string,
};

const mapRuntimeToProps = (state, ownProps, actions) => {
  const comment = ownProps.comment;
  const post = comment.post || getPost(state, comment.postId);
  const category = getCategory(state, post.categoryId);
  return {
    category,
    post,
    isPreview: isPreview(state),
    actionsOpened: actions.actionsOpened,
    actionsClosed: actions.actionsClosed,
    sectionUrl: getSectionUrl(state),
    showMessage: actions.showMessage,
  };
};

export default flowRight(
  connect(mapRuntimeToProps),
  withTranslate,
  withPermissions,
  withDeviceType,
  withAuth,
  withNativeShare,
)(CommentActions);
